/**
 * TEMU 展示逻辑：
 * 1）优先使用订单 GraphQL 字段（后端从 `extra_info.temuSorting` JSON 的 `hasDangerousGoods` / `isScf` 推导）；
 * 2）若无则回退：从 `sortingCode` 三段码解析（与 `wms/bags/NewTemuBagForm` 的 GA-G-LA 等形式一致）。
 */
export function parseTemuSortingCodeSegments(sortingCode: string | undefined | null): {
    temuBusinessType: string | null;
    hazmatSegment: string | null;
} {
    if (!sortingCode?.trim()) {
        return { temuBusinessType: null, hazmatSegment: null };
    }
    const parts = sortingCode.split('-');
    if (parts.length < 2) {
        return { temuBusinessType: null, hazmatSegment: null };
    }
    const first = parts[0]?.trim();
    const second = parts[1]?.trim();
    const temuBusinessType = first === 'SCF' || first === 'GA' ? first : null;
    const hazmatSegment = second === 'G' || second === 'H' ? second : null;
    return { temuBusinessType, hazmatSegment };
}

/** 详情展示：优先用后端从 extra_info.temuSorting 解析的字段，否则回退为分拣码三段解析 */
export function resolveTemuDisplayFromOrder(order: {
    temuDangerousGoodsSegment?: string | null;
    temuBusinessTypeSegment?: string | null;
    sortingCode?: string | null;
} | undefined | null): {
    temuBusinessType: string | null;
    hazmatSegment: string | null;
} {
    const fromApiH = order?.temuDangerousGoodsSegment?.trim();
    const fromApiB = order?.temuBusinessTypeSegment?.trim();
    if (fromApiH || fromApiB) {
        return {
            hazmatSegment: fromApiH || null,
            temuBusinessType: fromApiB || null,
        };
    }
    return parseTemuSortingCodeSegments(order?.sortingCode);
}
